module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 81.6,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.8,
						"dataLabels": {
							"enabled": true,
							"format": "86",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.8,
						"dataLabels": {
							"enabled": true,
							"format": "81",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 55.2,
						"dataLabels": {
							"enabled": true,
							"format": "69",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 34.4,
						"dataLabels": {
							"enabled": true,
							"format": "43",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.76160990712074,
						"dataLabels": {
							"enabled": true,
							"format": "319",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.9969040247678,
						"dataLabels": {
							"enabled": true,
							"format": "281",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.28173374613003,
						"dataLabels": {
							"enabled": true,
							"format": "269",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 72.44582043343654,
						"dataLabels": {
							"enabled": true,
							"format": "234",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.94117647058824,
						"dataLabels": {
							"enabled": true,
							"format": "171",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.43074003795066,
						"dataLabels": {
							"enabled": true,
							"format": "524",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.04554079696395,
						"dataLabels": {
							"enabled": true,
							"format": "464",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.11195445920305,
						"dataLabels": {
							"enabled": true,
							"format": "438",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.19354838709677,
						"dataLabels": {
							"enabled": true,
							"format": "391",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 52.371916508538895,
						"dataLabels": {
							"enabled": true,
							"format": "276",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.63583394027677,
						"dataLabels": {
							"enabled": true,
							"format": "1368",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.76402039329935,
						"dataLabels": {
							"enabled": true,
							"format": "1205",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.68536052439912,
						"dataLabels": {
							"enabled": true,
							"format": "1149",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.40786598689003,
						"dataLabels": {
							"enabled": true,
							"format": "1104",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.85506190823015,
						"dataLabels": {
							"enabled": true,
							"format": "863",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -18.400000000000006,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.686274509803921,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.813953488372093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.814814814814813,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -37.68115942028986,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.2383900928792602,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.91222570532915,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.270462633451954,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.011152416356875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -26.923076923076927,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5692599620493399,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.45038167938931,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.603448275862066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.730593607305938,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -29.411764705882348,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.36416605972323657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.915204678362567,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.6473029045643095,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.9164490861618773,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.82971014492754,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=125"
			},
			{
				"x": 9,
				"text": "30–39<br>n=323"
			},
			{
				"x": 15,
				"text": "40–49<br>n=527"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1373"
			}
		],
		"dataTable": {
			"< 30": [
				125,
				102,
				86,
				81,
				69,
				43
			],
			"30–39": [
				323,
				319,
				281,
				269,
				234,
				171
			],
			"40–49": [
				527,
				524,
				464,
				438,
				391,
				276
			],
			"≥ 50": [
				1373,
				1368,
				1205,
				1149,
				1104,
				863
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 202
// module chunks = 0